module.exports = __webpack_public_path__ + "images/emoji/koala.5b4f2ed836d6fb395dd7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/koala.png
// module id = Q4Q2
// module chunks = 2